// extracted by mini-css-extract-plugin
export default {"indicator":"Album_indicator__ZSmIS","arrow":"Album_arrow__KPkE5"};